// extracted by mini-css-extract-plugin
module.exports = {"token_text":"AddNewClientButton_token_text__KT2RI","button":"AddNewClientButton_button__nkJz-"};